// Version of the auth system a bundle/API implements, served at GET /v3/auth/version. Dates rather than names.
export const AUTH_VERSION_SUPABASE = '2026-09';
export const AUTH_VERSION_BETTER_AUTH = '2026-10';

export type AuthVersionResponse = {
  version: string;
};
